import request from "@/api/request";

/**
 * 获取学校配置（严格从接口获取，无默认兜底）
 * 接口地址：/api/getSchoolData
 * 入参：{ school: '学校标识' }
 * 返回结构：见下方示例
 */
export const getConfig = (params) => request({
    url: '/api/getSchoolData',
    method: 'get',
    params
})
